import React, { useState } from 'react';
import {
  withStyles,
  TextField,
  Fab,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import CloseIcon from '@material-ui/icons/Close';
import Done from '@material-ui/icons/Done';
import { useTranslation } from 'react-i18next';
import styles from '../styles';
import {
  Card, CardBody, CardHeader, CardIcon,
} from '~/components/Card';


const CommentBox = ({ value, onChange }) => {
  const { t: translate } = useTranslation();
  return (
    <TextField
      label={`${translate('common:Comment')}`}
      placeholder={`${translate('common:Comment')}`}
      multiline
      rows={15}
      variant="outlined"
      fullWidth
      value={value}
      onChange={onChange}
      InputProps={{
        style: {
          backgroundColor: '#f9f9f9',
          borderRadius: 8,
        },
      }}
    />
  );
};


const MaintenanceReportListRowModal = (
  {
    selectedMaintainanceListRow,
    onEdit,
    handleClose,
    handleDiscardChanges,
  },
) => {
  const { t: translate } = useTranslation();
  const [dataRow, setDataRow] = useState(selectedMaintainanceListRow);

  const onChangeDataRow = e => (
    setDataRow({
      ...dataRow,
      comment: e.target.value,
    })
  );

  return (
    <>
      <Card style={{ maxWidth: 1000 }}>
        <CardHeader icon>
          <>
            <CardIcon color="warning">
              <EditIcon />
            </CardIcon>
            <CardIcon
              onClick={handleClose}
              style={{
                float: 'right',
                cursor: 'pointer',
                background: 'darkgray',
                borderRadius: 50,
                boxShadow: '10px 10px 50px gray',
              }}
            >
              <CloseIcon />
            </CardIcon>
          </>
        </CardHeader>
        <CardBody>
          <CommentBox
            value={dataRow.comment}
            onChange={onChangeDataRow}
          />
          <hr />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '12px',
            }}
          >
            <Fab
              variant="extended"
              size="medium"
              color="primary"
              onClick={() => handleDiscardChanges(dataRow)}
            >
              <DeleteOutline />
              {translate('common:DiscardChanges')}
            </Fab>
            <Fab
              variant="extended"
              size="medium"
              color="secondary"
              onClick={() => {
                onEdit(dataRow);
              }
              }
              style={{
                color: '#FFF',
              }}
            >
              <Done />
              {translate('common:End')}
            </Fab>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

MaintenanceReportListRowModal.propTypes = {};

MaintenanceReportListRowModal.defaultProps = {};

export default withStyles(styles)(MaintenanceReportListRowModal);
